import { render, staticRenderFns } from "./InstructionCard1.vue?vue&type=template&id=268048be&"
import script from "./InstructionCard1.vue?vue&type=script&lang=js&"
export * from "./InstructionCard1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports